import React, { FC } from 'react';
import { Div, Heading, Span, P } from '@kizi/core-components';
import { PercentageBar } from '@kizi/comparator-components';
import { IProduct } from '@kizi/comparator-core';

interface SpeedPopupProps {
  data: IProduct;
}

export const SpeedPopup: FC<SpeedPopupProps> = ({ data }) => {
  const advertisedDownloadSpeed =
    data.servicesWrapper?.networkInformation?.internetSpeed?.downloadSpeedInMb;
  const advertisedUploadSpeed =
    data.servicesWrapper?.networkInformation?.internetSpeed?.uploadSpeedInMb;

  if (!advertisedDownloadSpeed || !advertisedUploadSpeed) {
    return null;
  }

  // Might need this function later
  // const calculatePercent = (expectedSpeed: number, advertisedSpeed: number) => {
  //   return Math.round((advertisedSpeed / expectedSpeed) * 100);
  // };

  //Text for bottom label is unknown for now
  const generateBottomLabel = () => {
    switch (data.servicesWrapper?.networkInformation?.network?.signal) {
      case 'vdsl':
      case 'adsl':
        return 'De werkelijke snelheid van VDSL-internet is afhankelijk van de afstand tot uw wijkcentrale en de kwaliteit van de lijn. Ook is het gebruik van een draadloos Wifi-netwerk en de kwaliteit van bekabeling binnenshuis van invloed op de uiteindelijke snelheid.';
      case 'glasvezel':
        return 'Bij glasvezelinternet is de up- en downloadsnelheid hetzelfde. Wel is het gebruik van een draadloos wifi-netwerk en de kwaliteit van bekabeling binnenshuis van invloed op de uiteindelijke snelheid.';
      case 'kabel':
        return 'Met kabelinternet is de downloadsnelheid vaak hoger dan de uploadsnelheid. Het gebruik van een draadloos Wifi-netwerk en de kwaliteit van bekabeling binnenshuis is van invloed op de uiteindelijke snelheid.';
      default:
        return '';
    }
  };

  return (
    <Div variant="internetSpeedPopupContainer">
      <Heading as="h5" variant="H5" mt="0" mb="2">
        Te verwachten snelheid
      </Heading>
      <Div variant="internetSpeedPopup">
        <P>Downloadsnelheid</P>
        <P>
          <Span>{`${advertisedDownloadSpeed} Mbit/s van ${advertisedDownloadSpeed} Mbit/s`}</Span>
        </P>
      </Div>
      <PercentageBar innerWidth={100} />
      <Div variant="internetSpeedPopup">
        <P>Uploadsnelheid</P>
        <P>
          <Span>{`${advertisedUploadSpeed} Mbit/s van ${advertisedUploadSpeed} Mbit/s`}</Span>
        </P>
      </Div>
      <PercentageBar innerWidth={100} />
      <Span>{generateBottomLabel()}</Span>
    </Div>
  );
};
